export default "__VITE_ASSET__CMtofDOE__"